import { UseQueryOptions, UseQueryResult, QueryKey } from '@tanstack/react-query'
import { ApiResult } from 'src/Libs/api'
import usePortalQuery from './use-portal-query'

interface Params<T> {
  queryKey: QueryKey
  fetchFunction: () => Promise<ApiResult<T>>
  options?: Omit<UseQueryOptions<T | null, Error, T, QueryKey>, 'queryKey' | 'queryFn' | 'select'>
}

/**
 * A custom hook that wraps the useQuery hook from react-query to handle ApiResult.
 * It simplifies the usage by directly returning the value instead of an ApiResult object.
 * If there are errors, it throws the error, which can be caught by the component using this hook.
 *
 * @deprecated Please use usePortalQuery instead which you can use as a drop-in replacement for useQuery and has better type safety and is more flexible. This hook will be removed in future releases.
 */
const useApiResultQuery = <T>({ queryKey, fetchFunction, options }: Params<T>): UseQueryResult<T, Error> => {
  return usePortalQuery<T, T, QueryKey>({
    queryKey,
    queryFn: fetchFunction,
    ...options,
  })
}

export default useApiResultQuery
